export default __webpack_public_path__ + "static/media/warning.f72cc363.svg";